
import Vue from "vue";
import startCase from "lodash/fp/startCase";
import Profile from "@/components/navigation/Profile.vue";
/**/
import LangSwitcher from "@/components/settings/LangSwitcher.vue";
/**/

export default Vue.extend({
  name: "NavBar",

  components: {
    Profile,
    /**/
    LangSwitcher,
    /**/
  },

  data: () => ({
    startCase,
    closeOnContentClick: true as boolean,
    showSearch: false as boolean,
    checked: false as boolean,
    logoImage: require("@/assets/images/logos/logo-icon.png"),
  }),

  computed: {
    moduleName() {
      return this.$route.name;
    },
  },

  methods: {
    toggleSideBar(): void {
      this.$store.dispatch("navigation/toggle");
    },
    toggleSearch(): void {
      this.showSearch = !this.showSearch;

      if (this.showSearch) {
        this.$nextTick(() => {
          (this.$refs.search as any).focus();
        });
      }
    },
  },
});
